import _ from 'underscore';
import { Base } from './Base';

export class SimpleBase extends Base {
  static create() {
    return undefined;
  }

  static isValidType(target) {
    return target === undefined || !_.isObject(target);
  }

  static isValid(target) {
    return this.isValidType(target);
  }

  static isEqual(a, b) {
    return a === b;
  }
}
